import { useAssignedSecondsWatcher } from 'infrastructure/hooks/conversation/use-assigned-seconds-watcher';
import useUser from 'utils/useUser';
import { useSelector } from 'react-redux';

import type { RootState } from 'store';

export const usePermissionForModifyLogic = () => {
  const user = useUser();

  const { currentConversation } = useSelector(
    (state: RootState) => state.smsDashboard,
  );

  const { isOverTime } = useAssignedSecondsWatcher({
    assignedAt: currentConversation.assignedAt,
  });

  const isAssignee = currentConversation.assignedByLogin === user.loginGuid;
  const isAssigned = !!currentConversation.assignedByLogin;

  const canModify = (isAssignee && !isOverTime) || isOverTime || !isAssigned;

  return { canModify };
};
